import React from "react";
import { Link } from "react-router-dom";
import FallbackImage from '../FallbackImage/FallbackImage';

const CategoryFeatureCard = ({ image, title, description, features, link }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 max-w-sm mx-auto">
      <div className="relative aspect-square overflow-hidden bg-[#F3F4F6] flex items-center justify-center">
        <FallbackImage
          src={`/${encodeURI(image)}`}
          alt={title}
          className="w-full h-full object-contain transition-transform duration-300 hover:scale-105"
          placeholderText={title}
        />
      </div>
      
      <div className="p-6">
        <h3 className="text-2xl font-bold text-heading mb-3">
          {title}
        </h3>
        <p className="text-gray-600 mb-4 leading-relaxed">
          {description}
        </p>
        
        <div className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-primary rounded-full"></div>
              <span className="text-sm text-gray-700">{feature}</span>
            </div>
          ))}
        </div>
        <div className="mb-4 text-left">
          <p className="text-sm font-medium text-[#FF6B35] mb-2">Available in</p>
          <div className="flex gap-2 justify-start">
            <span className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-transparent text-[#FF6B35] text-sm font-medium border-2 border-[#FF6B35] pointer-events-none select-none">
              Frozen
            </span>
            <span className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-transparent text-[#FF6B35] text-sm font-medium border-2 border-[#FF6B35] pointer-events-none select-none">
              Aseptic
            </span>
          </div>
        </div>
        <Link
          to={link}
          className="inline-block w-full bg-primary text-white font-semibold py-3 px-6 rounded-lg text-center hover:bg-orange-600 transition-colors duration-200"
        >
          Learn More
        </Link>
      </div>
    </div>
  );
};

export default CategoryFeatureCard;
